export const messages = {
    "wre-dashboard.nav-menu.item.shared": "共用",
    "wre-dashboard.nav-menu.item.backups": "備份",
    "wre-dashboard.nav-menu.item.machines": "電腦",
    "wre-dashboard.nav-menu.item.account": "帳戶",
    "wre-dashboard.search.input.hint": "搜尋",
    "wre-dashboard.search.label.breadcrumb": "搜尋結果",
    "wre-dashboard.search.message.empty": "沒有任何項目符合您的搜尋",
    "wre-dashboard.side-bar.selected.title:plural": "已選擇 {count} 個項目 | 已選擇 {count} 個項目",
    "wre-dashboard.side-bar.backup-type.disk": "磁碟",
    "wre-dashboard.side-bar.backup-type.file": "檔案",
    "wre-dashboard.side-bar.backup-type.notarized": "已公證的檔案和資料夾",
    "wre-dashboard.side-bar.backup-type.exchange": "應用程式 - Microsoft Exchange",
    "wre-dashboard.side-bar.backup-type.sql": "應用程式 - Microsoft SQL",
    "wre-dashboard.side-bar.backup-type.sys-state": "應用程式 - 系統狀態",
    "wre-dashboard.side-bar.backup-type.application": "應用程式",
    "wre-dashboard.space-indicator.label.left": "剩餘 {spaceFree}",
    "wre-dashboard.space-indicator.label.used": "{usedSpace} 已使用",
    "wre-dashboard.space-indicator.label.unlimited": "無限制",
    "wre-dashboard.backups-table.column.name": "名稱",
    "wre-dashboard.backups-table.column.size": "大小",
    "wre-dashboard.backups-table.column.version": "上次備份",
    "wre-dashboard.backups-table.message.no-backups": "雲端中尚無備份",
    "wre-dashboard.backups-sidebar.label.size": "大小",
    "wre-dashboard.backups-sidebar.label.type": "類型",
    "wre-dashboard.backups-sidebar.label.version": "最後版本",
    "wre-dashboard.backups-sidebar.label.created": "建立時間",
    "wre-dashboard.backups-sidebar.label.machine": "電腦",
    "wre-dashboard.backups-sidebar.label.owner": "擁有者",
    "wre-dashboard.content-table.column.name": "名稱",
    "wre-dashboard.content-table.column.versions": "版本",
    "wre-dashboard.content-table.column.volumes": "磁碟區",
    "wre-dashboard.content-table.column.path": "路徑",
    "wre-dashboard.content-table.column.size": "大小",
    "wre-dashboard.content-table.column.version": "最後版本",
    "wre-dashboard.content-table.action.versions": "版本",
    "wre-dashboard.content-table.action.restore": "下載",
    "wre-dashboard.content-table.action.share": "分享連結",
    "wre-dashboard.content-table.label.size": "大小",
    "wre-dashboard.content-table.label.created": "建立時間",
    "wre-dashboard.content-table.label.modified": "修改時間",
    "wre-dashboard.content-table.message.empty-folder": "此資料夾是空的",
    "wre-dashboard.password-dialog-box.title.backup": "加密備份",
    "wre-dashboard.password-dialog-box.title.archive": "加密存檔",
    "wre-dashboard.password-dialog-box.message.backup": "請指定存取備份 {displayName} 的密碼",
    "wre-dashboard.password-dialog-box.message.archive": "請指定存取存檔 {displayName} 的密碼",
    "wre-dashboard.password-dialog-box.hint.password": "密碼",
    "wre-dashboard.password-dialog-box.message.invalid-password": "密碼不正確",
    "wre-dashboard.form.button.open": "開啟",
    "wre-dashboard.form.button.close": "關閉",
    "wre-dashboard.form.button.cancel": "取消",
    "wre-dashboard.form.button.delete": "刪除",
    "wre-dashboard.shared-content-table.column.name": "名稱",
    "wre-dashboard.shared-content-table.column.location": "位置",
    "wre-dashboard.shared-content-table.column.source": "來源",
    "wre-dashboard.shared-content-table.column.days": "天",
    "wre-dashboard.shared-content-table.column.downloads": "下載",
    "wre-dashboard.shared-content-table.column.shared": "共用於",
    "wre-dashboard.shared-content-table.label.shared": "共用於",
    "wre-dashboard.shared-content-table.label.backup": "來源",
    "wre-dashboard.shared-content-table.action.share": "分享連結",
    "wre-dashboard.shared-content-table.action.settings": "連結設定",
    "wre-dashboard.shared-content-table.action.delete": "刪除連結",
    "wre-dashboard.shared-content-table.action.delete-selected": "刪除連結",
    "wre-dashboard.account-page.message.used-space": "{brandName}：可用空間 {spaceFree}，共 {totalSpace}",
    "wre-dashboard.account-page.message.used-unlimited-space": "{brandName}：無限制的空間",
    "wre-dashboard.account-page.button.sign-out": "登出",
    "wre-dashboard.account-page.button.manage-subscription": "管理授權",
    "wre-dashboard.account-page.message.subscription.active": "您的 {brandName} 空間授權將過期於",
    "wre-dashboard.account-page.message.subscription.trial": "{brandName} 試用版作用中，直到",
    "wre-dashboard.account-page.message.subscription.expired": "您的 {brandName} 空間授權已過期於",
    "wre-dashboard.account-page.message.worm-status.storage-full": "您的 {brandName} 儲存空間已滿。您無法將資料備份或存檔至雲端。",
    "wre-dashboard.account-page.message.worm-status.less-than": "低於 {percent}% 可用。您即將無法使用 {brandName}。",
    "wre-dashboard.versions-dialog-box.title": "{fileName} 的版本",
    "wre-dashboard.shared-link-dialog-box.share-view.button.copy": "複製連結",
    "wre-dashboard.shared-link-dialog-box.share-view.button.manage": "連結設定",
    "wre-dashboard.shared-link-dialog-box.share-view.message": "擁有此連結的任何人都可以檢視資料的最後版本",
    "wre-dashboard.shared-link-dialog-box.share-view.label.shared": "共用於 {creationDate}",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "已複製連結",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "連結複製錯誤",
    "wre-dashboard.shared-link-dialog-box.delete-view.title": "刪除連結",
    "wre-dashboard.shared-link-dialog-box.delete-view.message": "此連結將不再適用於擁有該連結的任何人",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.title": "刪除連結",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.message": "這些連結將不再適用於擁有這些連結的任何人",
    "wre-dashboard.shared-link-dialog-box.manage-view.title": "連結設定",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.delete": "刪除連結",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.apply": "完成",
    "wre-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "密碼",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "重設密碼",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "密碼保護",
    "wre-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "使用密碼保護此連結",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "到期",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "下載限制",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "在 {splitMarker} 天後停用此連結 | 在 {splitMarker} 天後停用此連結",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "在 {splitMarker} 下載後停用此連結 | 在 {splitMarker} 下載後停用此連結",
    "wre-dashboard.sub-accounts-dialog-box.title": "帳戶",
    "wre-dashboard.sub-accounts-dialog-box.search.input.hint": "搜尋",
    "wre-dashboard.sub-accounts-dialog-box.table.message.empty": "沒有任何項目符合您的搜尋",
    "wre-dashboard.sub-accounts-dialog-box.table.column.name": "名稱",
    "wre-dashboard.sub-accounts-dialog-box.table.column.usage": "用法",
    "wre-dashboard.sub-accounts-dialog-box.table.column.version": "上次備份",
    "wre-dashboard.sub-accounts-dialog-box.table.column.expires": "過期",
    "wre-dashboard.sub-accounts-dialog-box.label.used-space": "{spaceFree} 可用空間 {totalSpace}",
    "wre-dashboard.sub-accounts-dialog-box.label.volume-subscription": "大量訂購授權",
    "wre-dashboard.sub-accounts-dialog-box.label.expired": "到期",
    "wre-dashboard.machines-table.column.name": "名稱",
    "wre-dashboard.machines-table.column.size": "大小",
    "wre-dashboard.machines-table.message.no-machines": "雲端中尚無電腦"
};
